import { BackgroundBanner, RoomDetail, RoomFeed, RoomPreview, TopSection } from "@/domains/components";
import { useGetDMaxCommon, type RoomDMaxInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

export const Rooms = () => {
    const { roomIdx } = useParams<string>();

    const { data: room } = useGetDMaxCommon<RoomDMaxInfoResponse>({ section: "room" });
    // const bookingEngine = useBookingRecoilValue();

    const targetRoom = room?.rooms.find((t) => t.room_idx === roomIdx);
    const sector = {
        main: {
            firstLine: targetRoom?.room_name || "",
            secondLine: targetRoom?.room_intro || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };
    const otherRooms = room?.rooms.filter((t) => t.room_idx !== roomIdx);

    if (!roomIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return targetRoom && otherRooms ? (
        <>
            <TopSection imgList={targetRoom.imgList} sector={sector} />
            <RoomDetail room={targetRoom} />
            <RoomFeed room={targetRoom} />
            <BackgroundBanner img_URL={targetRoom.imgList[0]?.img_URL} />
            <RoomPreview room={{ rooms: otherRooms }} />
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
